import {ImportModel} from "../../models/import/ImportModel";
import {NotificationService} from "../../services/NotificationService";
import {BaseEntity} from "../../entities/BaseEntity";
import { StateService } from "@uirouter/angularjs";

export class ImportMapFieldsCtrl<T extends BaseEntity> {
    public static $inject = ['$scope','$state','ImportModel','NotificationService'];
    working:boolean = false;
    constructor(public $scope:any, public stateService:StateService, public model:ImportModel<T>, public notifyService:NotificationService) {
        this.$scope.vm = this;
    }
    previous():void{
        this.stateService.go(this.model.getRoute(""));
    }
    next():void{
        var ok:boolean = this.model.mapFields();
        if(!ok){
          this.notifyService.notifyError("Please select a value for all required fields.");
        }
        else {
          this.working = true;
          this.model.doImport(true).then((ok) => {
            if (ok) {
              this.stateService.go(this.model.getRoute("confirm"));
            }
            else {
              this.stateService.go(this.model.getRoute("fixerrors"));
            }
          }).catch((exc)=>{
            this.notifyService.notifyError("Got error in testing import:"+exc);
          }).finally(()=>{
            this.working = false;
          });
        }
    }
}
